/**
 * @fileoverview The i18next namespace the auth-shell string bundles register under.
 * @package @puffin-core/auth-shell
 *
 * A ZERO-IMPORT leaf module, mirroring `@puffin-core/login-shell`'s and
 * `@puffin-core/page-shell`'s `strings/namespace.js`. `useAuthShellTranslate()` is imported by
 * auth-shell components; routing it through `strings/index.js` would drag `en.js` and `es.js` into
 * those import chains for the sake of one constant. The barrel re-exports it so the name keeps a
 * single public import site.
 */

/**
 * The canonical namespace under which auth-shell strings live in i18next.
 * `useAuthShellTranslate()` returns a translator pre-bound to it.
 */
export const AUTH_SHELL_NAMESPACE = 'authShell';

export default AUTH_SHELL_NAMESPACE;
